export default {
  PUT_GRAYSCALE_COPY: "[fileUpload] put grayscale copy",
  // INSERTION_PT (for script, do not remove)
};
